export const CLEARRX_PHONE = '201-380-7700';
export const ENTRY_ID = 'entryId';

// Follows the ISO 639 Language Names
// https://en.wikipedia.org/wiki/List_of_ISO_639_language_codes
export const LANGUAGES_SUPPORTED = {
  ENGLISH: 'English',
  SPANISH: 'Spanish',
};
